import { defineMessages } from 'react-intl';

export const assumptionCreationModalMessageDefinitions = defineMessages({
  title: {
    id: 'assumptionCreationModal.title',
    defaultMessage: 'Creation of Assumption',
  },
  assumptionType: {
    id: 'assumptionCreationModal.assumptionType',
    defaultMessage: 'Assumption Type',
  },
  assumptionTypePlaceholder: {
    id: 'assumptionCreationModal.assumptionCategoryDropdownPlaceholder',
    defaultMessage: 'Select Type',
  },
  description: {
    id: 'assumptionCreationModal.description',
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: 'assumptionCreationModal.descriptionPlaceholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
});
